/**
 * Child-audience step/term icons are named keywords (e.g. "cat"), not raw emoji.
 * Older students may use raw Unicode symbols (★ ✓) — pass isChild=false to pass through.
 */
export const NAMED_ICONS: Record<string, string> = {
  cat: "🐱",
  dog: "🐶",
  rabbit: "🐰",
  frog: "🐸",
  fox: "🦊",
  bear: "🐻",
  lion: "🦁",
  bird: "🐦",
  fish: "🐟",
  bee: "🐝",
  elephant: "🐘",
  butterfly: "🦋",
  turtle: "🐢",
  penguin: "🐧",
  duck: "🦆",
  horse: "🐴",
  cow: "🐄",
  pig: "🐷",
  monkey: "🐵",
  star: "⭐",
  rainbow: "🌈",
  sun: "☀️",
  cloud: "☁️",
  rain: "🌧️",
  apple: "🍎",
  banana: "🍌",
  cake: "🎂",
  book: "📚",
  pencil: "✏️",
  balloon: "🎈",
  ball: "⚽",
  heart: "❤️",
  celebration: "🎉",
  trophy: "🏆",
  circle: "⭕",
  square: "🟦",
  triangle: "🔺",
  colour: "🎨",
  color: "🎨",
  vocabulary: "📚",
  meaning: "💭",
  word: "📝",
  noun: "🏷️",
  verb: "⚡",
};

const EMOJI_LIKE = /[^\u0000-\u007F]/;

/**
 * Resolve icon for display. Child: keyword → emoji. Non-child: return icon unchanged (Unicode symbols).
 */
export function resolveNamedIcon(icon: string | undefined, isChild: boolean): string | null {
  if (icon == null || icon === "") return null;
  if (!isChild) return icon;
  const key = String(icon).toLowerCase().trim();
  if (NAMED_ICONS[key]) return NAMED_ICONS[key];
  if (EMOJI_LIKE.test(icon)) return icon;
  return null;
}

/** Emoji fallback when Lottie fails — uses same keyword map as Lottie + generic pin */
export function emojiFallbackForKeyword(keyword: string): string {
  const k = keyword.toLowerCase().trim().split(/\s+/)[0];
  return NAMED_ICONS[k] || "📌";
}
